<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          <h4>Τιμολόγια</h4>
          <CButton color="primary" class="btn m-3 btn-primary" @click="createInvoice()">Προσθήκη τιμολογίου</CButton>
        </CCardHeader>
        <CCardBody>
          <CModal
            class="modalAlert"
            :show.sync="alertIsShown"
            :centered="true"
            size="lg"
          >
            <CAlert
              closeButton
              :show.sync="alertIsShown"
              color="primary"
              fade
            >
              {{ message }}
            </CAlert>
          </CModal>

          <!-- Search & Filter Bar -->
          <CRow class="mb-3 align-items-end">
            <CCol md="4">
              <label class="mb-1"><strong>Αναζήτηση</strong></label>
              <CInput
                v-model="search"
                placeholder="Επωνυμία, αριθμός, MARK..."
                @input="onSearchInput"
              />
            </CCol>
            <CCol md="3">
              <label class="mb-1"><strong>Σειρά</strong></label>
              <CSelect
                :options="seiraSelectOptions"
                :value.sync="selectedSeira"
                @change="onSeiraChange"
              />
            </CCol>
            <CCol md="2">
              <label class="mb-1"><strong>Ανά σελίδα</strong></label>
              <CSelect
                :options="perPageOptions"
                :value.sync="perPage"
                @change="fetchInvoices"
              />
            </CCol>
          </CRow>

          <CDataTable
            :items="items"
            :fields="fields"
            hover
            striped
            :loading="loading"
            sorter
            :sorter-value="sorterValue"
            @update:sorter-value="onSort"
            @row-clicked="(item, index, event) => showInvoice(item.id, event)"
            clickable-rows
          >
          <template #status="{item}">
            <td>
              <CBadge v-if="item.created_externally" color="info" class="mr-1">Εξωτερικό</CBadge>
              {{ item.status }}
            </td>
          </template>
          <template #total_price="{item}">
            <td>
              <span :style="priceColor(item.payment_status)">{{ item.total_price }}€</span>
            </td>
          </template>
          <template #actions="{item}">
            <td class="button-cell">
              <CButton
                color="info"
                class="btn-icon mr-2"
                @click.stop="openInNewTab( item.id )"
                v-c-tooltip="'Άνοιγμα σε νέα καρτέλα'"
              >
                <CIcon name="cilExternalLink" />
              </CButton>
              <CButton
                v-if="!item.created_externally"
                color="primary"
                class="btn-icon mr-2"
                @click.stop="editInvoice( item.id )"
                v-c-tooltip="'Επεξεργασία'"
              >
                <CIcon name="cilPencil" />
              </CButton>
              <CButton
                v-if="you!=item.id && (item.mark === null || item.mark === '') "
                color="danger"
                class="btn-icon"
                @click.stop="deleteInvoice( item.id )"
                v-c-tooltip="'Διαγραφή'"
              >
                <CIcon name="cilTrash" />
              </CButton>
            </td>
          </template>
        </CDataTable>

        <!-- Server-side Pagination -->
        <div class="d-flex justify-content-between align-items-center mt-3" v-if="totalPages > 1">
          <div class="text-muted">
            Σελίδα {{ currentPage }} από {{ totalPages }} ({{ totalItems }} τιμολόγια)
          </div>
          <nav>
            <ul class="pagination mb-0">
              <li class="page-item" :class="{ disabled: currentPage <= 1 }">
                <a class="page-link" href="#" @click.prevent="goToPage(1)">«</a>
              </li>
              <li class="page-item" :class="{ disabled: currentPage <= 1 }">
                <a class="page-link" href="#" @click.prevent="goToPage(currentPage - 1)">‹</a>
              </li>
              <li
                v-for="page in visiblePages"
                :key="page"
                class="page-item"
                :class="{ active: page === currentPage }"
              >
                <a class="page-link" href="#" @click.prevent="goToPage(page)">{{ page }}</a>
              </li>
              <li class="page-item" :class="{ disabled: currentPage >= totalPages }">
                <a class="page-link" href="#" @click.prevent="goToPage(currentPage + 1)">›</a>
              </li>
              <li class="page-item" :class="{ disabled: currentPage >= totalPages }">
                <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">»</a>
              </li>
            </ul>
          </nav>
        </div>

        </CCardBody>
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'

const fields = [
  {
    key: 'status',
    label: 'Κατάσταση'
  },
  {
    key: 'document_number',
    label: 'Αριθμός',
    _style: 'width: 100px;'
  },
  {
    key: 'client_company',
    label: 'Επωνυμία'
  },
  {
    key: 'document_series_id',
    label: 'Τύπος παραστατικού'
  },
  {
    key: 'document_series_seira_id',
    label: 'Σειρά',
    _style: 'width: 100px;'
  },
  {
    key: 'service',
    label: 'Υπηρεσία'
  },
  {
    key: 'total_price',
    label: 'Ποσό'
  },
  {
    key: 'consultant',
    label: 'Σύμβουλος'
  },
  {
    key: 'actions',
    label: '',
    sorter: false,
    filter: false
  }
]

export default {
  name: 'Invoices',
  data: () => {
    return {
      sorterValue: { column: 'status', asc: false },
      items: [],
      fields,
      // Server-side pagination
      currentPage: 1,
      perPage: 10,
      totalItems: 0,
      totalPages: 1,
      // Search & filters
      search: '',
      searchTimeout: null,
      selectedSeira: '',
      seiraOptions: [],
      perPageOptions: [
        { value: 10, label: '10' },
        { value: 25, label: '25' },
        { value: 50, label: '50' },
        { value: 100, label: '100' }
      ],
      // UI state
      you: null,
      message: '',
      alertIsShown: false,
      showMessage: false,
      loading: true,
    }
  },
  computed: {
    seiraSelectOptions() {
      let options = [{ value: '', label: 'Καμία επιλογή' }];
      this.seiraOptions.forEach(s => {
        options.push({ value: s.id, label: s.name });
      });
      return options;
    },
    visiblePages() {
      const pages = [];
      const total = this.totalPages;
      const current = this.currentPage;
      let start = Math.max(1, current - 2);
      let end = Math.min(total, current + 2);

      // Show at least 5 pages if available
      if (end - start < 4) {
        if (start === 1) {
          end = Math.min(total, start + 4);
        } else if (end === total) {
          start = Math.max(1, end - 4);
        }
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  watch: {
    alertIsShown: function(newVal) {
      if (!newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    fetchInvoices() {
      let self = this;
      self.loading = true;

      const params = {
        token: localStorage.getItem("api_token"),
        page: self.currentPage,
        per_page: self.perPage,
        search: self.search,
        sort_by: self.getSortColumn(),
        sort_dir: self.sorterValue.asc ? 'asc' : 'desc',
      };

      if (self.selectedSeira) {
        params.seira = self.selectedSeira;
      }

      axios.get('/api/invoices', { params })
      .then(function (response) {
        self.items = response.data.invoices;
        self.totalItems = response.data.total;
        self.totalPages = response.data.last_page;
        self.currentPage = response.data.current_page;

        // Set seira options once
        if (response.data.seira_options && self.seiraOptions.length === 0) {
          self.seiraOptions = response.data.seira_options;
        }

        self.loading = false;
      }).catch(function (error) {
        console.log(error);
        self.loading = false;
        self.$router.push({ path: '/login' });
      });
    },
    getSortColumn() {
      const col = this.sorterValue.column;
      const map = {
        'status': 'created_at',
        'document_number': 'document_number',
        'client_company': 'client_company',
        'total_price': 'payment_status',
      };
      return map[col] || 'created_at';
    },
    onSearchInput() {
      // Debounce search - wait 400ms after user stops typing
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1;
        this.fetchInvoices();
      }, 400);
    },
    onSeiraChange() {
      this.currentPage = 1;
      this.fetchInvoices();
    },
    onSort(val) {
      this.sorterValue = val;
      this.currentPage = 1;
      this.fetchInvoices();
    },
    goToPage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
      this.fetchInvoices();
    },
    invoiceLink (id) {
      return `invoices/${id.toString()}`
    },
    editLink (id) {
      return `invoices/${id.toString()}/edit`
    },
    showInvoice ( id, event ) {
      const invoiceLink = this.invoiceLink( id );

      // Check if Ctrl/Cmd key is pressed or middle-click
      if (event && (event.ctrlKey || event.metaKey || event.button === 1)) {
        // Open in new tab
        const route = this.$router.resolve({path: invoiceLink});
        window.open(route.href, '_blank');
      } else {
        // Navigate in same tab
        this.$router.push({path: invoiceLink});
      }
    },
    openInNewTab ( id ) {
      const invoiceLink = this.invoiceLink( id );
      const route = this.$router.resolve({path: invoiceLink});
      window.open(route.href, '_blank');
    },
    editInvoice ( id ) {
      const editLink = this.editLink( id );
      this.$router.push({path: editLink});
    },
    deleteInvoice ( id ) {
      let self = this;
      axios.post('/api/invoices/' + id + '?token=' + localStorage.getItem("api_token"), {
        _method: 'DELETE'
      })
      .then(function (response) {
          self.message = 'Επιτυχής διαγραφή τιμολογίου.';
          self.showAlert();
          self.fetchInvoices();
      }).catch(function (error) {
         if(error.response.data.message == 'The given data was invalid.'){
          self.message = '';
          for (let key in error.response.data.errors) {
            if (error.response.data.errors.hasOwnProperty(key)) {
              self.message += error.response.data.errors[key][0] + '  ';
            }
          }
          self.showAlert();
        }else{
          self.$router.push({ path: '/login' });
        }
      });
    },
    createInvoice () {
      this.$router.push({path: 'invoices/create'});
    },
    createExternalB2GInvoice () {
      this.$router.push({path: 'invoices/add-external-b2g'});
    },
    showAlert () {
      this.alertIsShown = true
    },
    priceColor(status) {
      if (status == 0) {
        return { color: 'red' }
      } else if (status == 1) {
        return { color: '#D6B85A' }
      } else if (status == 2) {
        return { color: 'green' }
      } else if (status == 3) {
        return { color: 'orange' }
      } else {
        return { color: 'black' }
      }
    },
  },
  mounted: function(){
    this.fetchInvoices();
  }
}
</script>

<style scoped>
/* Striped rows for better readability */
::v-deep tbody tr:nth-of-type(odd) {
  background-color: #f0f0f0 !important;
}

::v-deep tbody tr:nth-of-type(even) {
  background-color: #ffffff !important;
}

/* Hover effect for both odd and even rows */
::v-deep tbody tr:nth-of-type(odd):hover {
  background-color: #d0e8ff !important;
}

::v-deep tbody tr:nth-of-type(even):hover {
  background-color: #e3f2fd !important;
}

/* Constrain width of specific columns */
::v-deep th:nth-child(2),
::v-deep td:nth-child(2),
::v-deep th:nth-child(5),
::v-deep td:nth-child(5) {
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Prevent responsive table stacking on small screens */
::v-deep .table-responsive {
  overflow-x: auto;
}

::v-deep .table {
  table-layout: auto;
  min-width: 100%;
}

/* Keep buttons inline horizontally */
::v-deep td.button-cell {
  white-space: nowrap !important;
}

::v-deep td.button-cell button {
  display: inline-block;
  vertical-align: middle;
}

/* Icon buttons - compact and stylish */
::v-deep .btn-icon {
  padding: 0.375rem 0.5rem !important;
  min-width: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
}

::v-deep .btn-icon svg {
  width: 18px;
  height: 18px;
}

::v-deep .btn-icon:hover {
  transform: scale(1.1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* Pagination styling */
.pagination .page-link {
  padding: 0.375rem 0.75rem;
}

.pagination .page-item.active .page-link {
  background-color: #321fdb;
  border-color: #321fdb;
}
</style>
